import { useEffect } from "react";
import { useRequestHook } from "../utils/hooks/hooks";

export default function SsoKickoff() {
  const { handleRequest } = useRequestHook();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // ✅
    const tenantId = params.get("tenantId") || undefined;
    const loginHint = params.get("login_hint") || undefined;

    const redirectUrl = sessionStorage.getItem("postLoginUrl") || "/";
    const qs = new URLSearchParams({ redirect: redirectUrl });
    if (tenantId) qs.set("tenantId", tenantId);
    if (loginHint) qs.set("login_hint", loginHint);
    if (tenantId) qs.set("silent", "1");

    const url = `/login/microsoft/start?${qs.toString()}`;

    handleRequest("get", url, {}, (ok, msg, data) => {
      if (ok && data?.redirectUrl) {
        window.location.href = data.redirectUrl;
      } else {
        console.error("SSO kickoff failed:", msg || data);
        window.location.replace("/");
      }
    });
  }, []);

  return null;
}
